export const PICKED_ANSWER_START = 'PICKED_ANSWER_START';
export const PICKED_ANSWER_SUCCESS = 'PICKED_ANSWER_SUCCESS';
export const PICKED_ANSWER_FAIL = 'PICKED_ANSWER_FAIL';
export const PICKED_ANSWER_RESET = 'PICKED_ANSWER_RESET';
